import FilterBar from '../../components/FilterBar';
import { CircularProgress, TextField, Typography } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { filterConstraintChecker } from './rmaHistoryUtils';
import { RmaHistoryItemFilter } from './rmaHistoryTypes';
import { useFindAllCompaniesQuery } from '../../api/api-hooks';

interface Props {
  filters: RmaHistoryItemFilter;
  setFilters: React.Dispatch<any>;
  initialFilters: RmaHistoryItemFilter;
}

const LptRmaHistoryFilterBar = ({
  filters,
  setFilters,
  initialFilters,
}: Props) => {
  const { data: companies } = useFindAllCompaniesQuery({});
  if (companies === undefined) return <CircularProgress></CircularProgress>;
  return (
    <>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
        filterConstraintChecker={filterConstraintChecker}
        children={(
          handler: (event: any, value?: any, label?: string) => void
        ) => [
          <TextField
            name='nameId'
            label='Filter By RMA'
            variant='outlined'
            value={filters.nameId}
            onChange={handler}
          />,
          <Autocomplete
            onChange={(event, value) => {
              handler(event, value, 'company');
            }}
            value={filters.company}
            options={companies}
            getOptionLabel={(company) => company.companyName}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Filter By Company'
                name='company'
                variant='outlined'
                id='company'
              />
            )}
          />,
          <TextField
            name='serial'
            label='Filter By Serial'
            variant='outlined'
            value={filters.serial}
            onChange={handler}
          />,
          <Typography>Ship Date From:</Typography>,
          <TextField
            name='shipDateFrom'
            variant='outlined'
            type='date'
            value={filters.shipDateFrom}
            onChange={handler}
          />,
          <Typography>To:</Typography>,
          <TextField
            name='shipDateTo'
            variant='outlined'
            type='date'
            value={filters.shipDateTo}
            onChange={handler}
          />,
        ]}
      />
    </>
  );
};

export default LptRmaHistoryFilterBar;
